import { render, staticRenderFns } from "./VantActivityNewUserSecondPop.vue?vue&type=template&id=150528ce&"
import script from "./VantActivityNewUserSecondPop.vue?vue&type=script&lang=js&"
export * from "./VantActivityNewUserSecondPop.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports